import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconWarning = ({ t, className, height, width, fill }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 35 35'>
    <title>{t('Warning')}</title>
    <g transform='translate(-2 -2)' fill='none' fillRule='evenodd'>
      <rect width={39} height={39} rx={5} />
      <path
        d='M19.5 4.5c8.271 0 15 6.729 15 15s-6.729 15-15 15-15-6.729-15-15 6.729-15 15-15m0 32.5C29.15 37 37 29.15 37 19.5S29.15 2 19.5 2 2 9.85 2 19.5 9.85 37 19.5 37m0-7.5a1.877 1.877 0 0 0 1.875-1.875A1.877 1.877 0 0 0 19.5 25.75a1.877 1.877 0 0 0-1.875 1.875c0 1.034.841 1.875 1.875 1.875m0-6.875c1.035 0 1.875-.84 1.875-1.875v-7.5a1.876 1.876 0 0 0-3.75 0v7.5c0 1.035.84 1.875 1.875 1.875'
        fill={fill}
      />
    </g>
  </svg>
)

export default Icon(IconWarning)
